import { render, staticRenderFns } from "./DomesticLegal.vue?vue&type=template&id=0b5ce870"
import script from "./DomesticLegal.vue?vue&type=script&lang=js"
export * from "./DomesticLegal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports